document.addEventListener('theme:cart:open', () => {
  //console.error('Cart Open')
  initSlick()
});
document.addEventListener('theme:cart:add', () => {
  //console.error('Cart Add')
  initSlick()
});
document.addEventListener('theme:cart:update', () => {
  //console.error('Cart Update')
  initSlick()
});
document.addEventListener('theme:cart:loaded', () => {
  //console.error('Cart Loaded')
  initSlick()
});

function initSlick() {
  setTimeout(() => {
    const loader = document.getElementById('upsell-loader')
    const slider = document.getElementById('product-upsell-carousel')
    if (loader && !loader.classList.contains('hidden-loader')) {
      loader.classList.add('hidden-loader')
    }
    if (slider && slider.classList.contains('slick-initialized')) {
      //console.log('already slicked')
    } else {
      $('#product-upsell-carousel').slick({
        dots: true,
        appendDots: $('.upsell-dots'),
        arrows: false,
        infinite: true,
        speed: 1000,
        cssEase: 'ease',
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3000
      });
    }
  },2000)
}